var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8454 7.44047C13.9278 7.44047 13.1836 8.18462 13.1836 9.1022C13.1836 10.0209 13.9279 10.7649 14.8454 10.7649H18.4082C18.7879 10.7649 19.0957 11.0727 19.0957 11.4524C19.0957 11.832 18.7879 12.1399 18.4082 12.1399H14.8454C13.1683 12.1399 11.8086 10.7799 11.8086 9.1022C11.8086 7.42525 13.1684 6.06543 14.8454 6.06543H18.3803C18.76 6.06543 19.0678 6.37323 19.0678 6.75293C19.0678 7.13262 18.76 7.44047 18.3803 7.44047H14.8454Z",
    fill: "#F7A303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2812 9.04834C14.2812 8.66866 14.5891 8.36084 14.9687 8.36084H15.2411C15.6208 8.36084 15.9286 8.66866 15.9286 9.04834C15.9286 9.42812 15.6208 9.73584 15.2411 9.73584H14.9687C14.5891 9.73584 14.2812 9.42812 14.2812 9.04834Z",
    fill: "#F7A303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 5.46484C5.28125 5.08514 5.58905 4.77734 5.96875 4.77734H9.69041C10.0701 4.77734 10.3779 5.08514 10.3779 5.46484C10.3779 5.84454 10.0701 6.15234 9.69041 6.15234H5.96875C5.58905 6.15234 5.28125 5.84454 5.28125 5.46484Z",
    fill: "#F7A303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81419 3.62282C2.70294 4.64305 2.17187 6.34575 2.17187 9.23171C2.17187 12.1173 2.70292 13.82 3.81422 14.8403C4.94317 15.8769 6.84136 16.3717 10.0103 16.3717C13.1786 16.3717 15.0766 15.8769 16.2055 14.8404C17.3167 13.82 17.8478 12.1173 17.8478 9.23171C17.8478 6.34575 17.3167 4.64304 16.2055 3.6228C15.0767 2.58637 13.1787 2.0918 10.0103 2.0918C6.84131 2.0918 4.94313 2.58637 3.81419 3.62282ZM2.8843 2.60995C4.41959 1.20043 6.78435 0.716797 10.0103 0.716797C13.2358 0.716797 15.6003 1.20044 17.1354 2.60997C18.6883 4.03571 19.2228 6.24673 19.2228 9.23171C19.2228 12.2164 18.6883 14.4274 17.1354 15.8532C15.6003 17.2628 13.2358 17.7467 10.0103 17.7467C6.78429 17.7467 4.41955 17.2628 2.88427 15.8532C1.33135 14.4274 0.796875 12.2164 0.796875 9.23171C0.796875 6.24673 1.33134 4.03569 2.8843 2.60995Z",
    fill: "#F7A303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/Network.9198b22d2b64187e933c7d7dab47bb78.svg";
export { ForwardRef as ReactComponent };